export default __webpack_public_path__ + "static/media/BlackFrame02.8a5dc856.png";